import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Funciones';

export interface Funcion {
  idFuncion: number;
	funcion: string;
	subFunciones: any;
}

export class FuncionesAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarTodasFunciones(): AxiosPromise<Funcion[]> {
		return this.cliente.get(`/ListarTodasFunciones`);
	}

	ListarFunciones(): AxiosPromise<Funcion[]> {
		return this.cliente.get(`/ListarFunciones`);
	}

	ListarFuncionesPorDni(dni: string): AxiosPromise<Funcion[]> {
		return this.cliente.post({dni:dni},`/ListarFuncionesPorDni`);
	}

	CrearFuncion(funcion:any): AxiosPromise<any[]> {
		return this.cliente.post(funcion,`/CrearFuncion`);
	}
	
	EliminarFuncion(id: number): AxiosPromise<any> {
		return this.cliente.remove(id, `/EliminarFuncion`);
	}

	ModificarFuncion(funcion: any): AxiosPromise<any[]> {
		return this.cliente.put(funcion.idFuncion, funcion, `/ModificarFuncion`);
	}
}